module.exports = __webpack_public_path__ + "static/media/shopnearby-logo.17495fff.png";